/**
 * Mountuje TrustMate widget jako iframe srcdoc w product card na archive.
 *
 * Placeholder w PHP (partials/product-card.php) zostawia data-tm-srcdoc z gotowym
 * HTML iframe'a. Tu lazy-mountujemy iframe gdy karta wchodzi w viewport
 * (IntersectionObserver), żeby nie odpalić N requestów do trustmate.pro za jednym
 * razem na listingu 24+ produktów.
 *
 * Iframe wewnątrz postMessage'uje swoją wysokość (po render + każda mutacja
 * DOM) — tu nasłuchujemy i resize'ujemy iframe do realnej wysokości widgetu.
 */
export function initTrustmateCards() {
    const placeholders = document.querySelectorAll('.hn-tm-placeholder[data-tm-srcdoc]');
    if (!placeholders.length) return;

    const heightById = new Map();

    const mount = (el) => {
        if (el.dataset.tmMounted === '1') return;
        el.dataset.tmMounted = '1';

        const srcdoc = el.dataset.tmSrcdoc;
        const id = el.dataset.tmId;
        if (!srcdoc) return;

        const iframe = document.createElement('iframe');
        iframe.setAttribute('srcdoc', srcdoc);
        iframe.setAttribute('loading', 'lazy');
        iframe.setAttribute('scrolling', 'no');
        iframe.setAttribute('title', 'Rating');
        iframe.style.border = '0';
        iframe.style.width = '100%';
        iframe.style.height = '32px';
        iframe.style.display = 'block';
        iframe.dataset.tmId = id;

        // Jeśli zdążył już zgłosić wysokość przed mountem — zastosuj od razu.
        if (heightById.has(id)) {
            iframe.style.height = heightById.get(id) + 'px';
        }

        el.replaceChildren(iframe);
    };

    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    mount(entry.target);
                    io.unobserve(entry.target);
                }
            });
        // 500px rootMargin — zaczynamy load TM widgetu gdy karta jest ~jeden viewport
        // przed wjazdem. Daje czas iframe'owi na fetch + render zanim user widzi.
        // Mniej "loading spinner flash". Card poza tym zasięgiem nie obciąża TrustMate.
        }, { rootMargin: '500px' });
        placeholders.forEach((el) => io.observe(el));
    } else {
        placeholders.forEach(mount);
    }

    window.addEventListener('message', (e) => {
        const data = e.data;
        if (!data || data.hnTm !== 1 || !data.id) return;

        const h = parseInt(data.h, 10);
        if (!h || h < 16) return;

        heightById.set(data.id, h);
        const iframe = document.querySelector(`iframe[data-tm-id="${CSS.escape(data.id)}"]`);
        if (iframe) iframe.style.height = h + 'px';
    });
}
